/* ExerciseWindowConfigurationService / MaturityScheduleConfigurationService not available in production api-services build
import { DynamicTableV2 } from '@packages/table-builder';
import { Page } from '@packages/ui/layout';
import { axiosInstance } from '@/services/apiInterceptor';
import '@/apps/customer/domains/exercisability-tier-config/exercisability-tier-config.actions';
import { exercisabilityTierConfigTable } from './schema';
*/

export default function ExercisabilityTierConfigPage() {
  return null;
}
